import { useTranslation } from "react-i18next";
import { Suspense, useRef, useState } from "react";
import AppLoading from "../app-loading/app-loading";
import { Toast } from "primereact/toast";
import OutwardChallanSearch from "./OutwardChallan-search";
import { OutwardChallan } from "./OutwardChallan-Datatable";

const OutwardChallanMain = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const searchRef = useRef<any>(null);   
  const [loading, setLoading] = useState(false);
  const [logData, setLogData] = useState<any[]>([]);
  const [dateRange, setDateRange] = useState<{ start: Date | null; end: Date | null }>({
    start: null,
    end: null,
  });
  const [challanCount, setChallanCount] = useState<number>(0);

  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-right" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <h5 className="ml-1 mb-0">{t("Outward Challan")}</h5>
          </div>
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
              <OutwardChallanSearch
                ref={searchRef}
                setLoading={setLoading}
                onSearch={(data, count) => {
                  setLogData(data);
                  setChallanCount(count);
                }}
                onDateRangeChange={(start, end) => setDateRange({ start, end })}
              />
            </div>
          </div>
          <OutwardChallan
            data={logData}
            challanCount={challanCount}
            refreshData={() => searchRef.current?.search()} 
            startDate={dateRange.start}
            endDate={dateRange.end}
          />
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default OutwardChallanMain;
